export class RegisterNotificationUser {
  NotificationId: number;
  Acceptance: boolean;
  Content: string;
  Type: number;
  DateAcceptance: Date;
  DateNotification: Date;
}
